import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, WaterReflection } from './Sparkles';
export function PhilosophySection() {
  return <section className="py-32 px-6 bg-gradient-to-b from-pond-dark-lighter to-pond-dark relative overflow-hidden" data-id="element-133">
      {/* Subtle stillness effects */}
      <Sparkles count={6} className="opacity-40" data-id="element-134" />
      <WaterReflection className="top-1/4" data-id="element-135" />

      {/* Soft ambient glow */}
      <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-pond-blue/6 rounded-full blur-[180px] pointer-events-none" animate={{
      opacity: [0.4, 0.6, 0.4]
    }} transition={{
      duration: 15,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-136" />

      <motion.div className="max-w-4xl mx-auto text-center relative z-10" initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.5
    }} data-id="element-137">
        <h2 className="text-4xl md:text-6xl font-serif text-pond-cream mb-10 leading-tight" data-id="element-138">
          This Isn't Another
          <br data-id="element-139" />
          <span className="gradient-text" data-id="element-140">Productivity App</span>
        </h2>

        <div className="space-y-8 text-xl md:text-2xl font-light text-pond-cream-muted leading-relaxed max-w-2xl mx-auto" data-id="element-141">
          <p data-id="element-142">
            Pond won't buzz you to work harder. Won't shame you for a bad day.
            Won't turn presence into competition.
          </p>

          <motion.p className="font-serif italic text-2xl md:text-3xl text-pond-blue/80 py-6" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 1
        }} data-id="element-143">
            "Just a quiet space. A gentle reminder. A place to return to
            stillness."
          </motion.p>

          <p className="text-pond-cream/80" data-id="element-144">
            Pond — a calmer way to use your phone.
          </p>
        </div>
      </motion.div>
    </section>;
}